var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.length > 0)?_c('slider',{staticClass:"feed-widget",attrs:{"items":_vm.items,"config":_vm.config},scopedSlots:_vm._u([{key:"body",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_vm._t("body",null,{"item":item,"index":index})]}},(_vm.items.length > 1)?{key:"navigation",fn:function(){return [_vm._t("navigation")]},proxy:true}:null],true)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }